module.exports = __webpack_public_path__ + "static/media/bckg5.9a89ec69.png";